import * as React from "react";
const FundingIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M43.168 11H9a.836.836 0 0 0-.833.833v5h13.35a5.43 5.43 0 0 1 4.566-2.5c1.917 0 3.6 1 4.567 2.5H39c1.375 0 2.5 1.125 2.5 2.5V28.5h1.667a.836.836 0 0 0 .833-.833V11.833a.836.836 0 0 0-.833-.833Zm-8.334 18.75a2.497 2.497 0 0 1-2.5-2.5c0-1.383 1.117-2.5 2.5-2.5 1.384 0 2.5 1.117 2.5 2.5a2.497 2.497 0 0 1-2.5 2.5Zm-12.916 2.917A5.408 5.408 0 0 1 16.65 28.5a5.405 5.405 0 0 1 4.458-6.6 4.35 4.35 0 0 1 .809-.067 5.404 5.404 0 0 1 5.267 6.667 5.408 5.408 0 0 1-5.267 4.167ZM9 30.167a2.497 2.497 0 0 1-2.5-2.5c0-1.092.692-2.017 1.667-2.35.259-.1.541-.15.833-.15 1.383 0 2.5 1.116 2.5 2.5 0 .291-.05.575-.15.833A2.472 2.472 0 0 1 9 30.167ZM39 18.5H4.834a.836.836 0 0 0-.833.833v15.834c0 .458.375.833.833.833h34.167a.836.836 0 0 0 .833-.833V19.333a.836.836 0 0 0-.833-.833Z",
  clipRule: "evenodd"
}));
export default FundingIcon;